export default __webpack_public_path__ + "static/logo28-4d5e22f9f7b855555b22db3cff81151d.png";